import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { shutdown } from '@intercom/messenger-js-sdk';
import { Subscription, interval } from 'rxjs';
import { AuthService } from '../../../../shared/services/auth.service';
import { watsappURL } from '../../../../../env-config';
import { NotificationsService } from '../../../../shared/notifications/notifications.service';
import { NotificationTypes } from '../../../../shared/notifications/notifications.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  profile: any = null;
  companies: any = [];
  activeCompany: any;
  isManax = false;
  isAdmin = false;

  notifications: any = [];
  unreadNotificationsCount = 0;
  unreadTaskRequestNotificationsCount: any;

  constructor(
    private router: Router,
    public _AuthService: AuthService,
    private _notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.isManax = this._AuthService.isManax();
    this.isAdmin = this._AuthService.isRole('admin');
    this.profile = this._AuthService.profile();
    this.companies = this.profile.company;
    this.activeCompany = this._AuthService.companyIndex();

    this.getNotifications();
    this._notificationsService.countPendingTaskRequests();
    this.initNotificationsPolling();
  }

  // ------------------------------------------------------

  onCompanyOpen(i: number) {
    console.log(i, this.activeCompany)
    window.location.href = window.location.href.replace('/admin/' + this.activeCompany, '/admin/' + i);
    setTimeout(window.location.reload, 1000);
  }

  openAccount() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'account']);
  }

  openCompanySettings() {
    this.router.navigate(['/admin', this._AuthService.companyIndex(), 'settings-company']);
  }

  logout() {
    shutdown();
    window.location.href = '/';
  }

  showWhatsappLabel = true;
  openWhatsapp() {
    window.open(watsappURL({ text: 'Hola, tengo una duda sobre Manax', phone: '34613766415' }))
  }

  // -------------------------------------------------

  private notificationsSubscription!: Subscription;
  initNotificationsPolling() {
    this.notificationsSubscription = interval(5 * 60 * 1000).subscribe(x => {
      this.getNotifications();
      this._notificationsService.countPendingTaskRequests();
    });
  }

  getNotifications() {
    this._notificationsService.getNotifications().subscribe((notifications) => {
      const now = new Date().getTime();
      this.notifications = notifications.map((el: any) => {
        const differenceInMilliseconds = now - new Date(el.createdAt).getTime();
        const millisecondsInADay = 1000 * 60 * 60 * 24;
        const daysDifference = Math.floor(differenceInMilliseconds / millisecondsInADay);
        el.days = daysDifference;
        return el;
      });
      this.countUnread();
      this.countTaskRequestUnread();
    });
  }

  read(notification: any) {
    if (!notification.read) {
      notification.read = true;
      this._notificationsService.markAsRead(notification).subscribe(() => {
        this.performAction(notification);
      });
      this.countUnread();
      this.countTaskRequestUnread();
    } else {
      this.performAction(notification);
    }
  }

  performAction(notification: any) {
    const user = this._AuthService.profile();
    const targetId = notification.data.company;
    const index = user.company.findIndex((company: any) => company._id === targetId);
    let newPath = '';

    if (index !== -1) {
      if (notification.data.type == NotificationTypes.TIMETRACK_OUT_OF_RANGE) {
        newPath = `/admin/${index}/time-track?id=` + notification.data?.timeTrack;
      }

      else if (notification.data.type == NotificationTypes.UNCOMPLETED_TASK) {
        newPath = `/admin/${index}/calendar`;
      }

      else if (notification.data.type == NotificationTypes.NEW_TASK_DETAIL) {
        newPath = `/admin/${index}/tasks-list`;
      }

      else if (notification.data.type == NotificationTypes.NEW_COMMENT) {
        newPath = `/admin/${index}/tasks-comments`;
      }

      else if (notification.data.type == NotificationTypes.OVERDUE_INVOICE) {
        newPath = `/admin/${index}/billing-documents`;
      }

      else if (notification.data.type == NotificationTypes.OVERDUE_QUOTE) {
        newPath = `/admin/${index}/quotes`;
      }

      else if (notification.data.type == NotificationTypes.UNSIGNED_DELIVERY_NOTE) {
        newPath = `/admin/${index}/delivery-notes`;
      }

      else if (notification.data.type == NotificationTypes.NEW_TASK_REQUEST) {
        newPath = `/admin/${index}/task-requests`;
      }

      else {
        // nothing
      }
    }

    else {
      console.error("Company not found");
    }

    const url = window.location.href.replace(/\/admin\/\d+\/.*/, newPath);
    window.location.href = url;
    setTimeout(() => window.location.reload(), 5);
  }

  countUnread() {
    this.unreadNotificationsCount = this.notifications.filter((el: any) => !el.read).length;
  }

  countTaskRequestUnread() {
    this.unreadTaskRequestNotificationsCount = this.notifications.filter((el: any) => !el.read && el.data.type == "NEW_TASK_REQUEST").length;
    this._notificationsService.updateUnreadTaskRequestCount(this.unreadTaskRequestNotificationsCount);
  }

  ngOnDestroy() {
    this.notificationsSubscription.unsubscribe();
  }
}
